// src/theme.js
export const theme = {
  colors: {
    primary: '#0052cc', // Azul forte para botões de ação (mantido do seu form)
    secondary: '#1A1A1A', // Preto suave para textos
    accentTeal: '#9DD8D3', // Verde-água da logo
    white: '#ffffff',
    accentOrange: '#F26A33', // Laranja da logo
    accentPurple: '#C6BCF0', // Roxo das ondas
    background: '#FDFBF7', // Creme/Off-white (fundo principal)
    surface: '#FFFFFF', // Branco puro para cartões/inputs
    light: '#666666', // Cinza para textos secundários
    border: '#E0E0E0'
  },
  fonts: {
    main: "'Inter', 'Segoe UI', Roboto, sans-serif",
    display: "'Poppins', sans-serif", // Sugestão para títulos (se puder importar)
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
};